<template>

  <div class="flex">
    <a-select :class="klass"
                @change="onChange"
                :value="value"
                :placeholder="placeholder"
                :disabled="disabled">

        <a-select-option
          v-for="item in list"
          :key="item.key"
          :value="item.value">
          {{item.label}}
        </a-select-option>

      </a-select>

      <a-button class="btn" :disabled="disabled" @click="(event) => refreshDynamicSelect()">{{btnLabel}}</a-button>
  </div>

</template>

<script>

import eBase from '@/base/eBase.js'
import _ from 'underscore'

export default {

  props: {
    url:{required:true},
    options:{required:true},
    method:{required:false,default:'get'},
    klass:{required:false,default:'full-input'},
    placeholder:{required:false,default:'请选择'},
    value:{required:false,default:function() {return [];}},
    disabled:{required:false,default:false},
    emptyValue:{required:false,default:'小区'},
    selectFirst:{required:false,default:false},
    btnLabel:{required:false,default:'获取'},
    staticRecord:{required:false,default:function() {return {}}},
  },

  data() {
    return {
      list:[],
    }
  },

  created() {
    eBase.debug('[DynamicSelect.vue][created][enter]');
    this.init();
  },

  mounted() {
    eBase.debug('[DynamicSelect.vue][mounted][enter]');
  },

  watch:{
    options:{
      handler(newValue,oldValue) {
        const newOptions = _.extend(newValue,this.staticRecord)
        this.search(newOptions);
      },
      immediated:false
    },
    value:{
      handler(newValue,oldValue) {
      },
      immediated:false
    },
  },

  computed:{
  },

  methods:{

    init () {
      const newOptions = _.extend(this.options,this.staticRecord)
      this.search(newOptions)
    },

    search(options) {
      const self = this;
      eBase.send({url:this.url,params:options},this.method).then((res) => {
        self.list = this.getComputerList(res);

        const selectValue = self.list.filter(function(one){
          return one.selected == 'true'
        })[0];

        if( self.list.length > 0 && selectValue) {
          this.$emit('change',selectValue.value);
        }

        self.list.length > 0 && self.selectFirst && self.$emit('onSelectFirst',[self.list[0].key]);
        self.list.length > 0 && self.selectFirst && self.$emit('onFullSelectFirst',this.getItemByValue([self.list[0].key]));
        self.$emit('selectRenderComplete',self.list);
      },(res)=>{
        eBase.debug('[DynamicSelect.vue][search][erro]' + JSON.stringify(res));
      });
    },

    onChange (value) {
      this.$emit('change',value);
      this.$emit('fullChange',this.getItemByValue(value));
    },

    getItemByValue(value){
      let result = {};
      _.each(this.list,function(item) {
        if(item.key == value ) {
          result = _.clone(item);
        }
      });

      return result;
    },

    refreshDynamicSelect() {
      this.search({cid:this.staticRecord.cid,type:1});
    },

    getComputerList(res) {

      let result = [];

      let arr = res.data.list || res.data.data.list || res.data.data;

      _.each(arr,function (item) {
        let one = _.clone(item);

        if(_.has(item,'value')) {
          one.key = item.value + '';
          one.value = item.value + '';
        }

        if(_.has(item,'code')) {
          one.key = item.code + '';
          one.value = item.code + '';
        }

        if(_.has(item,'label')) {
          one.label = item.label + '';
        }

        if(_.has(item,'name')) {
          one.label = item.name + '';
        }

        if(_.has(item,'title')) {
          one.label = item.title + '';
        }

        result.push(one);

       });

      return result;
    }

  },// EOF methods
}
</script>



// WEBPACK FOOTER //
// src/components/select/DynamicRefreshSelect.vue